import { ShieldAlert, ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";

export function UnauthorizedPage({
  requiredPermission,
  title = "Access Restricted",
  message = "You do not have the required editorial permissions to view or manage this newsroom section."
}: {
  requiredPermission?: string;
  title?: string;
  message?: string;
}) {
  return (
    <div className="admin-page-flow">
      <div className="admin-card-panel flex flex-col items-center justify-center text-center py-16 px-6 max-w-lg mx-auto">
        <div className="w-14 h-14 rounded-full bg-amber-50 text-[#C99A2E] flex items-center justify-center mb-4 border border-amber-200">
          <ShieldAlert size={28} />
        </div>

        <h1 className="text-xl font-serif font-bold text-slate-900 mb-2">{title}</h1>
        <p className="text-xs text-slate-600 leading-relaxed mb-6">
          {message}
        </p>

        {requiredPermission && (
          <div className="bg-slate-100 px-3 py-1.5 rounded text-[11px] font-mono text-slate-600 mb-6">
            Required Permission: <span className="font-bold text-slate-800">{requiredPermission}</span>
          </div>
        )}

        <div className="flex items-center gap-3">
          <Link to="/admin" className="admin-btn-primary">
            <Home size={15} />
            <span>Return to Newsroom Dashboard</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
